const baseStyle = {};
const defaultProps = {
    size: 'md'
};
const sizes = {
    sm: {
        item: {
            minH: '32px',
            pt: '8px'
        }
    },
    md: {
        item: {
            minH: '40px',
            pt: '12px'
        }
    },
    lg: {
        item: {
            minH: '48px',
            pt: '14px'
        }
    }
};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
